export default {
	name: 'shopSubjectSignUpDetail',
	data() {
		return {
			ShopSubjectID: 0,
			getData: {},
			subject: {
				PayMoney: 0,
				isEnd: true
			},
			subjectCustomer: [],
			getCustomer: {},
			customerCode: '',
			singUP: {},

		};
	},
	created() {
		this.getData = () => {
			this.ShopSubjectID = this.$route.params.ShopSubjectID;
			this.$request.request({
				url: 'Shops/getShopSubject',
				data: {
					ShopSubjectID: this.ShopSubjectID
				},
				method: 'post'
			}).then(r => {
				if (r.result) {
					this.subject = r.subject;
					this.subjectCustomer = r.subjectCustomer;
				}
			});
		}
		this.singUP = (SubjectCustomerID, CustomerID) => {
			this.$request.request({
				url: 'borrowAndReturn/subjectCustomer',
				data: {
					ShopSubjectID: this.ShopSubjectID,
					SubjectCustomerID: SubjectCustomerID,
					CustomerID: CustomerID,
					OperatorID: this.$store.state.user.UserID
				},
				method: 'post'
			}).then(r => {
				this.getData();
				this.$uil.showMessage({
					text: r.message
				});
			});
		}

		this.getCustomer = function() {
			this.$request.request({
				url: 'borrowAndReturn/getCustomerByCodeOrPhone',
				data: {
					searchText: this.customerCode
				},
				method: 'post'
			}).then(res => {
				if (res.result) {
					this.customerCode = '';
					this.$uil.showMessage({
						type: 'confirm',
						text: res.customer.CustomerName + ' 确定报名？',
						ok: () => this.singUP(0, res.customer.CustomerID)
					});
				}
			})
		}

		this.getData();
	},
	methods: {
		cancleSingUp(i) {
			console.log(i);
			this.$uil.showMessage({
				type: 'confirm',
				text: i.CustomerName + '确定取消报名' + (i.Disbursements > 0 ? '并且退还' + i.Disbursements + '费用' : '') +
					'？',
				ok: () => this.singUP(i.SubjectCustomerID, i.Customerid)
			});
		},
		payMoney(i) {
			this.$uil.showMessage({
				type: 'confirm',
				text: i.CustomerName + ' 确认' + (i.inputMoney > 0 ? '缴费' : '退费') + i.inputMoney + '元？',
				ok: () => {
					this.$request.request({
						url: 'borrowAndReturn/subjectsPayMoney',
						data: {
							Disbursements: i.inputMoney,
							SubjectCustomerID: i.SubjectCustomerID,
							CustomerID: i.Customerid,
							OperatorID: this.$store.state.user.UserID
						},
						method: 'post'
					}).then(r => {
						this.getData();
						this.$uil.showMessage({
							text: r.message
						});
					});

				}
			});

		}

	},
	computed: {},
	filters: {
		rmb(v) {
			return v + '¥';
		}
	},
	activated() {
		this.getData();
	}



}
